import {Page} from "../../../flair/Page.es6";
import Chart from "chart.js/auto";

Page.match("/app/va/").go(function() {
	let dateFromInput = document.querySelector("input[name='date-from']");
	let dateToInput = document.querySelector("input[name='date-to']");
	if(dateToInput.value && dateToInput.value < dateFromInput.value) {
		dateToInput.value = "";
		dateToInput.form.submit();
	}

	let [labelArray, datasetArray] = extractTable(document.querySelector(".data table"));

	let chartType = "line";
	let chartOptions = {};
	let modeInput = document.querySelector("input[name='mode'][checked]");
	if(modeInput.value === "symbol" || modeInput.value === "impairment") {
		chartType = "bar";
		chartOptions.scales = {
			x: {
				stacked: true,
			},
			y: {
				stacked: true,
			}
		};
	}
	else {
		if(datasetArray[0]){
			datasetArray[0].borderWidth = 6;

		}
	}

	let c = new Chart(
		document.querySelector(".chart-panel-item .chart canvas"), {
			type: chartType,
			data: {
				labels: labelArray,
				datasets: datasetArray,
			},
			options: chartOptions,
		});
});

/**
 * Returns a tuple of two arrays: [labelArray, datasetArray]
 * labelArray is an indexed array of the labels to use (x axis)
 * datasetArray is an array of indexed arrays. The inner arrays contain the raw data.
 */
function extractTable(table) {
	let labelArray = [];
	let datasetArray = [];

	let headerArray = [];
	for(let [i, th] of Array.from(table.tHead.rows[0].cells).entries()) {
		let text = th.textContent.trim();
		if(text[0] === "*") {
			text = text.substring(1);
			if(i > 0) {
				continue;
			}
		}

		headerArray.push(text);
	}

	let defaultDataSet = {
		data: [],
		label: null,
		hitRadius: 32,
	};
	for(let i = 0; i < headerArray.length - 1; i++) {
		datasetArray.push(structuredClone(defaultDataSet));
	}

	for(let tr of Array.from(table.tBodies[0].rows)) {
		let datasetArrayIndex = 0;
		for(let [i, td] of Array.from(tr.cells).entries()) {
			let th = table.tHead.rows[0].cells[i];
			let thText = th.textContent.trim();

			if(i === 0) {
				let tdText = td.textContent.trim();
				if(tdText.match(/^\d\d\d\d-\d\d-\d\d$/)) {
					let date = new Date(tdText);
					tdText = date.toLocaleDateString("en-GB", {
						day: "numeric",
						month: "short",
						year: "2-digit",
					});
				}
				labelArray.push(tdText);
			}

			if(thText[0] === "*") {
				continue;
			}

			if(datasetArray[datasetArrayIndex].label === null) {
				datasetArray[datasetArrayIndex].label = thText;
			}

			datasetArray[datasetArrayIndex].data.push(td.textContent.trim());
			datasetArrayIndex++;
		}

	}

	// console.log(labelArray, datasetArray);
	return [labelArray, datasetArray];
}
